// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M9.48063 2.5H1V21H23V5H11.4806L9.48063 2.5ZM6.99805 11.998H9.00195V14.002H6.99805V11.998ZM10.998 11.998H13.002V14.002H10.998V11.998ZM17.002 11.998V14.002H14.998V11.998H17.002Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-folder-details-filled')
export default class FolderDetailsFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'folder-details-filled',
    }
  }
}
